import { FormAsistirActividad } from "../actividades/FormAsistirActividad";

export const FormAsistirComida = FormAsistirActividad;
